import React from 'react';

export default function AssignNumber(props) {

  return (
    <div className="MedalsNumberAssign">
        {props.numberToDisplay}
    </div>
  );
}